

































































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import ProfileForm from '@/components/users/profiles-form.vue';
import { convertCharacters } from '@/helpers/convertCharacters';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import * as service from '@/services/profiles';
import { ACCESS_TYPE_CLIENT, ACCESS_TYPE_EMEDE } from '@/settings/consts/users';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    ProfileForm,
    UiSelectClients,
  },
})
export default class Profiles extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
    client: null,
    type: false,
  };

  public types: any[] = [
    {
      value: '1',
      label: 'Emede',
    },
    {
      value: '2',
      label: 'Cliente',
    },
  ];

  public headers: any = [
    { text: 'Nome', value: 'nome' },
    { text: 'Tipo', value: 'tipo' },
    { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
  ];
  public data = [];
  public idSelected: number;

  public clients: any[] = [];
  public ufs: any[] = [];

  public accessTypes = {
    emede: ACCESS_TYPE_EMEDE,
    client: ACCESS_TYPE_CLIENT,
  };

  public beforeMount(): void {
    this.load();
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = convertCharacters(
      this.filter.term.toString().toLowerCase(),
    );
    const type = !!this.filter.type ? this.filter.type : null;

    return items.filter((row) => {
      return (
        (!row.descricao ||
          filter(convertCharacters(row.descricao.toLowerCase()), searchLower)) &&
        (!type || row.tipo.id === type)
      );
    });
  }

  public onEditItem(item): void {
    this.idSelected = item.id;
    this.formIsEdit = true;
    this.formOpen = true;
  }

  public saveItem(): void {
    this.closeForm();
    this.load();
  }

  public newItem(): void {
    this.idSelected = null;
    this.formIsEdit = true;
    this.formOpen = true;
  }

  public closeForm(): void {
    this.idSelected = null;
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    service.getProfiles().subscribe(
      (res) => {
        this.data = res;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
